import { getAxiosClient } from "../../axios-client";
import {
  SubcontractorNotificationRequestBody,
  SubcontractorNotificationResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const offerSubcontractorNotification = async (
  body: SubcontractorNotificationRequestBody
) => {
  return await axiosClient.ax.post<SubcontractorNotificationResponse>(
    "/Offers/OfferSubcontractorNotification2",
    body
  );
};
